function onready(callback) {
  if (document.readyState != "loading") {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}

function onload(callback) {
    if (document.readyState == "complete") {
        callback()
    } else {
        window.addEventListener("load", callback);
    }
}

function oneEventListener(el, eventType, callback) {
    function wrappedCallback(event) {
        callback = callback.bind(this);
        callback(event);
        el.removeEventListener(eventType, wrappedCallback);
    }
    el.addEventListener(eventType, wrappedCallback);
}

export {onready, onload, oneEventListener}
